import {LocationDetails} from '@models/locationDetails/location-details';
import {TrafficLightConfiguration} from '@models/machine/traffic-light/traffic-light-configuration';

export class DashboardMachine {
  id: number = -1;
  parentId: number = -1;
  location: string = '';
  locationDetails: LocationDetails | undefined = undefined;
  name: string = '';
  type: string = '';
  category: string = '';
  tenant: string | null = '';
  projectId: string = '';
  datasetLocation: string = '';
  tableauProjectId: string = '';
  machineTag: string = '';
  trafficLightConfiguration: TrafficLightConfiguration = new TrafficLightConfiguration();
  chartConfig: any;
  trafficLightClass: string = '';
  machineCategoryId: number = -1;
}
